import { render, staticRenderFns } from "./qualificationReviewList.vue?vue&type=template&id=2da97cde&scoped=true"
import script from "./qualificationReviewList.vue?vue&type=script&lang=js"
export * from "./qualificationReviewList.vue?vue&type=script&lang=js"
import style0 from "./qualificationReviewList.vue?vue&type=style&index=0&id=2da97cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da97cde",
  null
  
)

export default component.exports